<template>
  <div class="lang-switcher" ref="root">
    <button type="button" class="lang-switcher__btn" :aria-expanded="open" @click="open = !open">
      <img v-if="currentFlag" :src="currentFlag" class="lang-switcher__flag" alt="" />
      <span>{{ currentLabel }}</span>
      <i class="fas fa-chevron-down lang-switcher__chevron" aria-hidden="true" />
    </button>
    <ul v-show="open" class="lang-switcher__menu" role="listbox">
      <li v-for="item in languages" :key="item.code" role="option">
        <button
          type="button"
          class="lang-switcher__option"
          :class="{ 'lang-switcher__option--active': item.code === currentLanguage }"
          @click="select(item.code)"
        >
          <img :src="item.flag" class="lang-switcher__flag" :alt="item.nameKey" />
          <span>{{ item.nameKey }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { SUPPORTED_LANGUAGES, normalizeLanguage } from '@/i18n/languages';

export default {
  name: 'LanguageSwitcher',
  data() {
    return { open: false, languages: SUPPORTED_LANGUAGES };
  },
  computed: {
    currentLanguage() {
      return normalizeLanguage(this.$store.state.language);
    },
    currentLabel() {
      const item = this.languages.find((l) => l.code === this.currentLanguage);
      return item ? item.nameKey : 'Language';
    },
    currentFlag() {
      const item = this.languages.find((l) => l.code === this.currentLanguage);
      return item ? item.flag : this.languages[0].flag;
    },
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
  methods: {
    ...mapMutations(['setLanguage']),
    select(code) {
      this.setLanguage(normalizeLanguage(code));
      this.open = false;
    },
    onClickOutside(e) {
      if (this.$refs.root && !this.$refs.root.contains(e.target)) this.open = false;
    },
  },
};
</script>

<style scoped>
.lang-switcher { position: relative; z-index: 1; }
.lang-switcher__btn {
  display: inline-flex; align-items: center; gap: 6px; padding: 6px 10px;
  border: 1px solid rgba(255,255,255,0.35); border-radius: 8px;
  background: rgba(255,255,255,0.12); color: #fff; font-size: 12px; font-weight: 700; cursor: pointer;
}
.lang-switcher__chevron { font-size: 10px; opacity: 0.85; }
.lang-switcher__flag { width: 20px; height: 20px; border-radius: 50%; object-fit: cover; }
.lang-switcher__menu {
  position: absolute; top: calc(100% + 4px); right: 0; z-index: 1100; min-width: 160px;
  margin: 0; padding: 4px; list-style: none; border-radius: 10px; background: #fff;
  box-shadow: 0 8px 24px rgba(0,0,0,0.25);
}
.lang-switcher__option {
  display: flex; align-items: center; gap: 8px; width: 100%; padding: 8px 10px;
  border: none; border-radius: 6px; background: transparent; color: #010d28;
  font-size: 13px; font-weight: 600; text-align: left; cursor: pointer;
}
.lang-switcher__option:hover, .lang-switcher__option--active { background: rgba(212,175,55,0.2); }
</style>
